// extracted by mini-css-extract-plugin
export default {"groupGiftTagWrapper":"groupGiftTagWrapper__MzhkY","groupGiftTag":"groupGiftTag__OWM3N"};